export const defaultDebounceTime = 300;
export const defaultGlowTime = 5000;
export const maximumGuests = 5;
